import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import './utils/rem.js'; //vue自适应配置文件
import './utils/css/base.css'//页面样式初始化
// 引入请求方式
import request from './utils/request'
Vue.prototype.$api = request
// 引入animate.css动态库
import 'animate.css';

Vue.config.productionTip = false


import VueI18n from 'vue-i18n'
import ru from './locale/ru.json'// 俄语
import zh from './locale/zh.json'// 中文
import kk from './locale/kk.json'// 哈萨克语
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.state.language, // 默认语言
  fallbackLocale: 'zh',
  messages: {
    ru,
    zh,
    kk
  }
})


new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
